/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'network-security-policy';

export const networkSecurityPolicyModalBreadcrumbTitle = `${prefix}.networkSecurityPolicyModalBreadcrumbTitle`;
export const networkSecurityRuleModalBreadcrumbTitle = `${prefix}.networkSecurityRuleModalBreadcrumbTitle`;
export const burstSizeLabel = `${prefix}.burstSizeLabel`;
export const maxRateLabel = `${prefix}.maxRateLabel`;

export const ENGLISH = {
    [networkSecurityPolicyModalBreadcrumbTitle]: 'Network Security Policy',
    [networkSecurityRuleModalBreadcrumbTitle]: 'Network Security Rule',
    [burstSizeLabel]: 'Burst Size',
    [maxRateLabel]: 'Max Rate',
};
